import { render, staticRenderFns } from "./u-dialog.vue?vue&type=template&id=5f0ccf3c&scoped=true&"
import script from "./u-dialog.vue?vue&type=script&lang=js&"
export * from "./u-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f0ccf3c",
  null
  
)

export default component.exports